<div class="footer-image col-md-12 col-sm-6 mb-4 mb-md-0"></div>